module.exports = __webpack_public_path__ + "img/kaffee.665c887b.jpg";